import { hslToRgb } from "utils/hslToRgb";
import {
  ZONE_HUE_STEP_DEG,
  ZONE_LIGHTNESS,
  ZONE_SATURATION,
} from "../constants";
import type { BuildZoneColorMap } from "./types";

export const buildZoneColorMap: BuildZoneColorMap = ({ zones }) =>
  new Map(
    zones.map((zone, index) => [
      zone.id,
      hslToRgb({
        hue: (index * ZONE_HUE_STEP_DEG) % 360,
        saturation: ZONE_SATURATION,
        lightness: ZONE_LIGHTNESS,
      }),
    ]),
  );
